<template>
    <div class="" style="padding:.2rem 0 8rem 0">

        <div class="order-success">
            <div class="icon"></div>
            <div class="title">报名成功</div>
            <div class="desc"><p style="text-align: center">【重要】请仔细阅读下列说明</p>
                <p>1、报名成功后，请务必添加下方培训专属群！</p>
                <p>加群方式：群二维码截图-打开微信-扫一扫-相册-选择保存的群二维码图片即可</p>
                <p>2、本次培训含有线上培训内容，啦啦之星平台为指定培训课程平台，请用微信扫描下课程兑换码（本码仅限观看课程《全国啦啦操委员会新周期培训课程》，并非啦啦之星VIP年费会员），方可开始学习；注意：请在有效期内兑换，请用本人微信扫码兑换，一人一码，任何转借、外发，恕不再补；</p></div>
        </div>
            <van-cell-group>

                <van-cell
                        input-align="right"
                        title="单位"
                        :value="row.danwei"
                />
                <van-cell
                        input-align="right"
                        title="场次"
                        :value="row.station_name"
                />
                <van-cell
                        input-align="right"
                        title="时间"
                        :value="row.station.startdate+'至'+row.station.enddate"
                />
                <van-cell
                        input-align="right"
                        title="地点"
                        :value="row.station.province+'  '+row.station.city+' '+row.station.county"
                />

            </van-cell-group>

        <div style="text-align: center">
            <van-button
                    style="width: 3rem ; margin: 0 auto"
                    size="normal" round @click="goFiles(1)">培训通知下载</van-button>
            <van-button
                    style="width: 3rem ; margin: 0 auto"
                    size="normal" round @click="goFiles(2)">导师团</van-button>
        </div>
        <div class="order-success"  v-if="row.learn_erweima" >
            <p v-if="row.erweiimg.length>0" >扫码进入小程序,在线学习</p>
            <img :src="row.learn_erweima"/>
        </div>
        <div class="order-success">
            <img :src="row.erweiimg[0].url" v-if="row.erweiimg.length>0" />
            <p v-if="row.erweiimg.length>0" >扫码加工作人员好友，进入培训微信群</p>
        </div>

        <div class="savebtn">
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round v-rblink="{name:'HuiyiApplyList'}" >我的报名记录</van-button>
        </div>



        <van-action-sheet
                v-model="ltShow"
                :actions="ltActions"
                cancel-text="取消"
                @select="onLtSelect"
                close-on-click-action
                @cancel="ltShow=false"
        />

    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .order-success{
        text-align: center;
        margin: 20px 0 ;
    }
    .order-success .icon{
        background: url(../../../assets/images/icon-order-done.png);
        background-size: 100%;
        width: 75px;
        height: 75px;
        margin: 20px auto 20px auto;

    }
    .order-success .title{
        font-size: 18px;
        font-weight: bold;
        color: #000;
        text-align: center;
    }
    .order-success .desc{
        padding: 10px;
        text-align: left;
    }
    .order-success .desc p{
        line-height: 26px;
        font-size: 14px;
        color: #333;
        text-align: left;
    }
    .order-success img{
        width: 90%;
        /*height: 120px;*/
        margin: 10px auto;
    }
    .order-success p{
        font-size: 12px;
        color: #999;
    }

    .sai-shuo-li{
        background: #f3f3f3;
        border-radius: 10px;
        margin: 20px 10px ;
        padding: 10px;
    }
    .sai-shuo-li img{
        width: 50px;
        height: 50px;
        border-radius: 6px;
        float: left;
        margin-right: 10px;
    }
    .sai-shuo-li .c{
        width: calc(100% - 80px);
        border-right: 1px solid #00000008 ;
    }
    .sai-shuo-li .c .title{
        font-size: 14px;
        color: #000;
    }
    .sai-shuo-li .c .desc{
        font-size: 12px;
        color: #999;
    }
    .sai-shuo-li .fr{
        width: 70px;
        float: right;
    }
    .sai-shuo-li .btn{
        width: 60px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        text-align: center;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:6px;
        color: #fff;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }



</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,ActionSheet,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';


    import jquery from 'jquery';
    jquery.fn.longPress = function(fn) {
        let timeout = 0;
        const $this = this;
        console.log('jquery.fn.longPress')
        for (let i = 0; i < $this.length; i++) {
            $this[i].addEventListener('touchstart', () => {
                timeout = setTimeout(fn, 800); // 长按时间超过800ms，则执行传入的方法
            }, false);
            $this[i].addEventListener('touchend', () => {
                clearTimeout(timeout); // 长按时间少于800ms，不会执行传入的方法
            }, false);
        }
    };

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyFormStep2',
        components: {
            [Field.name]: Field,
            PicUploader,
            FileUploader,
        },
        data: function () {
            return {
                ltShow:false,
                ltImgSrc:'',
                ltImgName:'',
                ltActions:[{ name: '保存图片' }],
                validator,
                saveLoading:false,
                showFamliyPicker:false,
                showSubjectPicker:false,
                showJiaolianPicker:false,
                showRoomTypePicker:false,
                showMemberPicker:false,
                formData:{
                    id:0
                },
                row:{
                    erweiimg:[],
                    station:{

                    }
                }
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
            if(that.formData.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onLtSelect(item){
                let that = this;
                switch (item.name){
                    case '保存图片':
                        let name = that.ltImgSrc.split('?')[0].split('/').pop();
                        console.log(that.ltImgSrc,name);
                        appEvent({
                            name: 'downloadPic',
                            query: {
                                'filename' : name,
                                'url' : that.ltImgSrc
                            }
                        });
                        break;
                }
            },
            goList(){
                rbLink({name:'HuiyiApplyList',query:{}},'repalce');
            },
            goFiles(type){
                rbLink({name:'HuiyiFilesList',query:{ station_id:this.row.station.id ,type:type}});
            },
            onQuestion(){
                console.log('onQuestion')
            },
            fetch(){
                let that = this;
                that.$api.post('/api/huiyi/successdetail', {
                    id:that.formData.id
                }, (res) => {
                    that.row = res.data;


//                    if(window.isApp()){
                        setTimeout(()=>{
                            jquery('img').each(function(){
                            jquery(this).longPress(() => {
                                console.log('longPress',jquery(this).attr('src'));
                            that.ltImgSrc = jquery(this).attr('src')
                            that.ltImgName = jquery(this).attr('title')
                            that.ltShow =  true;
                        });
                        })
                    },500);
                        return false;
//                    }


            }, (res) => {
                    Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormSuccess.vue?57376917